export default "__VITE_ASSET__D9S3nOLF__"